import { Typography, withTypographyContainer } from 'shared/ui/typography';
import { MarginBottom } from './styles';
import { OrderPersonNotes } from './OrderPersonNotes';
import { OrderTags } from '../OrderInfo/OrderTags';
import { formatPhoneNumber } from 'shared/lib/string';
import { PersonData } from 'entities/person';
import { FC } from 'react';
import { CopyField } from 'shared/ui/copyField/copyField';


interface OrderPersonInfoContentProps {
	person: PersonData;
}

export const OrderPersonInfoContent: FC<OrderPersonInfoContentProps> = ({
	person,
}) => {
  const EnhancedTypography = withTypographyContainer(Typography);
  
	return (
		<>
      {person.phone && (
        <MarginBottom $value='12px'>
          <EnhancedTypography isBold={true} colorVariant="main">
            <CopyField value={formatPhoneNumber(person.phone).toString()}>
              {formatPhoneNumber(person.phone)}
            </CopyField>
          </EnhancedTypography>
        </MarginBottom>
      )}

			<MarginBottom $value='12px'>
				<EnhancedTypography isBold={true}>
					<CopyField value={person.name}>
						{person.name}
					</CopyField>
				</EnhancedTypography>
			</MarginBottom>

			<MarginBottom $value={(person.tags && person.tags.length > 0) ? '12px' : '0'}>
				<OrderPersonNotes
					person={person}
					variant={'transparent'}
					padding="8px"
				/>
			</MarginBottom>

			{person.tags && person.tags.length > 0 && (
				<OrderTags tags={person.tags} forOrder={false} />
			)}
		</>
	);
};
